import React, { useEffect, useState} from "react";
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import BigNumber from "bignumber.js";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import LinearProgress from '@material-ui/core/LinearProgress';
import Link from '@material-ui/core/Link';
import { useSnackbar } from 'notistack';
import { earFormat, addressFormat } from '../helper/formatter'
import EarthaToken from "../contracts/EarthaToken.json";
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { IconButton, InputAdornment } from "@material-ui/core";
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import "../style/number.css";

const BuyToken = ({ accounts, sales, onConnect, readSales, config, setBackdrop }) => {
  const [purchaserAddress, setPurchaserAddress] = useState("")
  const [beneficiaryAddress, setBeneficiaryAddress] = useState("")
  const [eth, setEth] = useState("")
  const [ethChange, setEthChange] = useState(false)
  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [loadEstimate, setLoadEstimate] = useState(false)
  const [estimate, setEstimate] = useState(false)
  const [estimateOrg, setEstimateOrg] = useState(false)
  const [address, setAddress] = useState()
  const [targetHash, setTargetHash] = useState("")
  const [tokenAddress, setTokenAddress] = useState("0xE73536245BC7fDddcd7C54FE4F3BcC1cCe7bcD1a")
  const [copyCheck, setCopyCheck] = useState(false)

  const setState = async () => {
    if (accounts && beneficiaryAddress === "") {
      setPurchaserAddress(accounts[0])
      setBeneficiaryAddress(accounts[0])
    }
    if (readSales && address !== readSales._address) {
      setAddress(readSales._address);
    }
  }

  const onBuy = async () => {
    setBackdrop(true)
    try {
      const isOpen = await readSales.methods.isOpen().call()
      if (!isOpen) {
        enqueueSnackbar("Sale is not open", { variant: 'error' })
        setBackdrop(false)
        return
      }
      const cap = await readSales.methods.cap().call()
      const soldTokens = await readSales.methods.soldTokens().call()
      if (!(BigNumber(soldTokens).plus(BigNumber(estimateOrg))).isLessThanOrEqualTo(BigNumber(cap))) {
        enqueueSnackbar("cap exceeded", { variant: 'error' })
        setBackdrop(false)
        return
      }

      const decimals = new BigNumber(18);
      const decimalPowed = new BigNumber(10).pow(decimals);
      const value = new BigNumber(eth).multipliedBy(decimalPowed);

      await sales.methods.buyTokens(
        beneficiaryAddress
      ).send({
        from: accounts[0],
        value: value.toString()
      }).on("transactionHash", (hash) => {
        setTargetHash(hash)

        setOpen(false)
        setBackdrop(false)
        const networkId = process.env.REACT_APP_NETWORK_ID
        const token = EarthaToken.networks[networkId];
        setTokenAddress(token && token.address)
        setOpenSuccess(true)
      })
    } catch (e) {
      setBackdrop(false)
    }
  }
  useEffect(() => {
    setState()
  })

  const calcEstimate = async () => {
    setLoadEstimate(true);
    const decimals = new BigNumber(18);
    const decimalPowed = new BigNumber(10).pow(decimals);
    const value = new BigNumber(eth).multipliedBy(decimalPowed);
    const _estimate = await readSales.methods.estimate(value.toString()).call()
    setEstimateOrg(_estimate)
    setEstimate(new BigNumber(_estimate).div(new BigNumber(10).pow(18)).toString(10))
    setLoadEstimate(false);
  }

  const ethOnChange = (e) => {
    setEthChange(true)
    setEth(e.target.value.trim())
  }

  const ethValueCheck = (_ethChange = ethChange) => {
    if (!_ethChange) {
      return false
    }
    const bn = BigNumber(eth).dp(18, BigNumber.ROUND_DOWN)
    return bn.isNaN() || bn.isLessThanOrEqualTo(0)
  }

  const inputErrorCheck = () => {
    let error = false
    setEthChange(true)
    if (ethValueCheck(true)) {
      // setToAddressError(true)
      error = true
    }
    return error
  }

  const handleClickOpen = () => {
    if (inputErrorCheck()) {
      return
    }
    calcEstimate()
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleSuccessClose = () => {
    setOpenSuccess(false);
  };
  const handleCopyTokenAddress = () => {
    navigator.clipboard.writeText(tokenAddress)
    setCopyCheck(true)
    setTimeout(() => {
      setCopyCheck(false)
    }, 1000);
  };

  return (
    <Container style={{marginTop:32}}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <Container className="MuiOutlinedInput-input">
            <Typography variant="h6" style={{ fontWeight: "bold" }}>
              STEP1:
            </Typography>
          </Container>
        </Grid>
        <Grid item xs={12} sm={8}>
          <Container className="MuiOutlinedInput-input" style={{ paddingLeft: 0, paddingRight: 0 }}>
            <Button style={{ width: "100%" }} variant="contained" color="primary" onClick={onConnect} disabled={!readSales || sales !== undefined}>
              {purchaserAddress ? addressFormat(purchaserAddress) :
                "Connect Wallet"
              }
            </Button>
          </Container>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Container className="MuiOutlinedInput-input">
            <Typography variant="h6" style={{ fontWeight: "bold" }}>
              STEP2:
            </Typography>
          </Container>
        </Grid>
        <Grid item xs={12} sm={8}>
          <TextField
            InputLabelProps={{ shrink: true }}
            variant="filled"
            helperText={''}
            error={ethValueCheck()}
            onChange={ethOnChange}
            value={eth}
            fullWidth={true}
            InputProps={{
              endAdornment: <InputAdornment position="end">BNB</InputAdornment>,
            }}
            inputProps={{
              style: { textAlign: "right" }
            }}
            disabled={!readSales}
            type="number"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Container className="MuiOutlinedInput-input">
            <Typography variant="h6" style={{ fontWeight: "bold" }}>
              STEP3:
            </Typography>
          </Container>
        </Grid>
        <Grid item xs={12} sm={8}>
          <Container className="MuiOutlinedInput-input" style={{ paddingLeft: 0, paddingRight: 0 }}>
            <Button style={{ width: "100%" }} variant="contained" color="primary" onClick={handleClickOpen} disabled={sales == undefined}>
              Buy EAR(confirm)
            </Button>
          </Container>
        </Grid>
        <Grid container>
          <p style={{ padding: "0 18.5px", margin: 0, fontSize: "0.95rem" }}>
            *After sending BNB, click this Adress to see your transacion.<br />
          </p>
          <p style={{ padding: "0 18.5px", margin: 0, fontSize: "0.75rem", width: "100%"  }}>
            SalesContractAddress:
          </p>
          <p style={{ padding: "0 18.5px", margin: 0, fontSize: "0.75rem", width: "100%"  }}>
            {address !== undefined &&
              <Link style={{wordBreak:"break-all"}} href={config.etherscan.getAddressUrl(address)} target="_blank">
                {address}
              </Link>
            }
          </p>
        </Grid>
      </Grid>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogContent>
          <Container>
            <Typography align="center">
              Your BNB
            </Typography>
            <Typography variant="h4" align="center">
              {eth}BNB
            </Typography>
            <Typography variant="h4" align="center">
              {loadEstimate ? <LinearProgress /> : "≒ " + earFormat(estimate) + " EAR"}
            </Typography>
          </Container>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined" >
            Close
          </Button>
          <div style={{ flex: '1 0 0' }} />
          <Button onClick={onBuy} color="primary" autoFocus variant="contained" disabled={loadEstimate} >
            {/* <FormattedMessage id="App.CreateEscrow.Dialog.Create" /> */}
            Buy EAR
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openSuccess}
        onClose={handleSuccessClose}
      >
        <DialogContent>
          <Container>
            <Typography variant="h4" align="center">
              Success!
            </Typography>
            <br />
            <Typography>
              If you see this screen,
            </Typography>
            <Typography>
              your wallet has already received the EAR.
            </Typography>
            <br />
            <Typography>
              Add EAR to your wallet
            </Typography>
            <Link href="#" style={{ color: "#e07000", wordBreak: "break-all" }}>
              <Typography align="center" onClick={handleCopyTokenAddress}>
                {tokenAddress}
                <IconButton onClick={handleCopyTokenAddress} size="small">
                  {copyCheck ?
                    <CheckCircleOutlineOutlinedIcon /> :
                    <FileCopyIcon />
                  }
                </IconButton>
              </Typography>
            </Link>
            <Typography>
              See your transacion.
            </Typography>
            <Typography align="center" style={{ wordBreak: "break-all" }}>
              {targetHash && (
                <Link href={config.etherscan.getTranUrl(targetHash)} target="_blank">
                  {targetHash}
                </Link>
              )}
            </Typography>
          </Container>
        </DialogContent>
        <DialogActions>
          <div style={{ flex: '1 0 0' }} />
          <Button onClick={handleSuccessClose} variant="outlined" >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
export default BuyToken;
